import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import ro from './Localization/local.ro.json';
import en from './Localization/local.en.json';
import hu from './Localization/local.hu.json';
import de from './Localization/local.de.json';

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: localStorage.getItem('language') ?? 'en',
    fallbackLng: 'en',
    resources: {
      en: { translation: en },
      ro: { translation: ro },
      hu: { translation: hu },
      de: { translation: de },
    },
    debug: true,
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;
